import { Icon } from '@iconify/react'
import { ErrorComponentProps } from '@tanstack/react-router'

import { Alert, AlertDescription, AlertTitle, Button } from '~in-app/components/shadcn-ui'

const DefaultError = (props: ErrorComponentProps) => {
  return (
    <Alert
      className="flex items-center justify-between"
      variant="error"
    >
      <div className="flex justify-center">
        <Icon
          height="16"
          icon="lucide:circle-alert"
          width="16"
        />

        <div className="ml-2 flex flex-col">
          <AlertTitle>{props.error.name}</AlertTitle>

          <AlertDescription>
            {props.error.message}
          </AlertDescription>
        </div>

      </div>

      <Button
        color="error"
        size="small"
        variant="text"
        onClick={props.reset}
      >
        Reset
      </Button>
    </Alert>
  )
}

export { DefaultError }
